var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('home-hero'),_c('home-resume'),_c('home-blog'),_c('home-reading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }